import { MultiSearchScreen } from '../features/multisearch'

export function MultiSearchPage() {
  return <MultiSearchScreen />
}
